import { Subscribable } from '@volkswagen-onehub/feature-hub-utils';
export class Observer extends Subscribable {
    constructor(value) {
        super();
        this.value = value;
    }
    update(newValue) {
        this.value = newValue;
        this.updateInternal(newValue);
    }
}
